import axios from '../../plugins/axios';

export const updateServiceFolder = ({}, { data, serviceId }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.put(`/api/service/${serviceId}/folder/${data.id}`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
};

export const createServiceFolder = ({}, { data, serviceId }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = {
    headers: { Authorization: `Bearer ${token}` }
  }
  return axios.post(`/api/service/${serviceId}/folder`, data, config)
    .then((response) => response )
    .catch((error) => error.response );
}
